import React from "react";
import { Button, Checkbox } from "react-materialize";

export default function TableRow({ data, index, handleEvents }) {
  const keyName = "recip-table";
  return (
    <tr key={keyName + "-row-" + index}>
      <td key={keyName + "-cell-" + index + "-col-type"} className="">
        {data.name}
      </td>
      <td key={keyName + "-cell-" + index + "-col-senttype"} className="">
        {data.senttype.toUpperCase()}
      </td>
      <td key={keyName + "-cell-" + index + "-col-country"} className="">
        {data.country}
      </td>
      <td key={keyName + "-cell-" + index + "-col-department"} className="">
        {data.department}
      </td>
      <td key={keyName + "-cell-" + index + "-col-salesoffice"} className="">
        {data.sale_office_code}
      </td>
      <td key={keyName + "-cell-" + index + "-col-agentcode"} className="">
        {data?.agent_name
          ? `${data.agent_name} (${data.agent_code})`
          : data?.agent_code
          ? `${data.agent_code}`
          : "-"}
      </td>
      <td key={keyName + "-cell-" + index + "-col-remove"} className="">
        <Checkbox
          checked={data?.checkedRemove ?? false}
          filledIn
          id={"checkbox-remove-item-" + data.id}
          name="remove-item"
          className={"checkbox-remove-item"}
          label={""}
          value={data.id.toString()}
          data-index={index}
          onChange={handleEvents.OnChange}
        />
        {/* <Button 
                className={"recip-btn-remove btn-small red"} 
                node="button" 
                waves="light"
                onClick={() => handleEvents.OnClick(data)} >
                REMOVE
            </Button> */}
      </td>
    </tr>
  );
}
